import React, {Dispatch, SetStateAction} from "react";
import { IPerson } from "./intarfaces";

export type TModeConv = "set" | "report" | "view" | "remove" | "delete";

export enum MessageTypeNames {
  TEXT_MSG = "text_message",
  INVITE_MSG = "invite_message",
  REMOVE_CHAT_MESSAGE = "remove_chat",
  REMOVE_INTEREST = "remove_interest",
  PLACE_NO_LONGER_AVAILABLE = "place_not_available"
}

export enum MessageActions {
  MESSAGE_NEW = "message_new",
  MESSAGE_UPDATE = "message_update",
  MESSAGE_DELETE = "message_delete",
  MESSAGE_READ = "message_read",
}

export enum ActionsSocketNames {
  TEXT_MESSAGE_CREATED = "text_message_created",
  TEXT_MESSAGE_UPDATED = "text_message_updated",
  TEXT_MESSAGE_DELETED = "text_message_deleted",
  INVITE_MESSAGE_CREATED = "invite_message_created",
  INVITE_MESSAGE_DELETED = "invite_message_deleted",
  INVITE_MESSAGE_READ = "message_read",
}

export enum InviteStatus {
  CREATED = "created",
  ACCEPTED = "accepted",
  REJECTED = "rejected",
  REMOVED = "removed_tenant",
}

export interface TMessageText {
  text: string;
}

export interface TMessageInvite {
  invite_dates: {
    offered_check_in_date: string;
    offered_check_out_date: string;
  };
  invite_msg_status: InviteStatus;
}

export interface ISocketMessage {
  action: MessageActions;
  body: { text: string };
  author_id: string;
  is_read: boolean;
  chat_id: string;
  created_at?: string;
  updated_at?: string;
}

export interface ISocketResponseMsg {
  author_id: string;
  body: TMessageText | TMessageInvite;
  chat_id: string;
  created_at: string;
  is_read: boolean;
  deleted: boolean;
  msg_type: MessageTypeNames;
  updated_at: string;
}

export interface ISocketResponse {
  action: ActionsSocketNames;
  body: ISocketResponseMsg;
}

export interface TMessage
  extends Omit<Required<ISocketMessage>, "action" | "body"> {
  msg_type: MessageTypeNames;
  body: TMessageText | TMessageInvite;
  deleted: boolean;
}

export type TArgFuncSendMsg = (
  newMsg: string,
  mode?: MessageActions,
  create_at?: string
) => void;

export interface IMessagesList extends React.HTMLAttributes<HTMLDivElement> {
  chater: IDataConv;
  newMessage: ISocketResponse;
  handleMessage: TArgFuncSendMsg;
  setLatestRead: (time: string[]) => void
  latestRead: string[]
}

export type THandleSingleConv = (
  chat: string,
  mode: TModeConv,
  person: string,
  house: string
) => void;

export type TUserShot = Pick<
  IPerson,
  "first_name" | "last_name" | "thumbnail_url" | "user_id"
>;

export type TConversation = TUserShot & { chat_id: string; house_id: string, unread: boolean, lastMessageTime: string };

export interface IChater {
  chat_id: string;
  host_most_recent_read_at: string
  host_most_recent_unread_at: string
  student_most_recent_read_at: string
  student_most_recent_unread_at: string
  created_at: string;
  updated_at: string;
  student_id: string;
  host_id: string;
  house_id: string;
  chatted: boolean;
  lastMessageDate?: string;
}

export interface IDataConv {
  name: string;
  chat_id: string;
  user_id: string;
  house_id: string;
  name_house?: string;
}

export interface ISingleConversation {
  person: TConversation;
  lastMessageTime: string;
  lastMessageDate: string | undefined;
  isActive: boolean;
  unreadConversations: string[];
  unread: boolean,
  closeChat: (flag: boolean) => void;
  setUnreadConversations: Dispatch<SetStateAction<string[]>>;
  handleActiveConversation: THandleSingleConv;
}

export interface IReportUser {
  chat_id: string;
  reporter_id: string;
  reportee_id: string;
}
